

































import Vue from "vue";

export default Vue.extend({
    name: "StatusToggle",
    props: {
        value: {
            type: Boolean,
            required: false,
            default: false
        },
        label: {
            type: String,
            required: false,
            default: ""
        },
        ariaLabel: {
            type: String,
            required: false,
            default: "Toggle status"
        },
        hideLabel: {
            type: Boolean,
            required: false,
            default: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        actionable: {
            type: Boolean,
            required: false,
            default: false
        },
        tooltip: {
            type: String,
            required: false,
            default: ""
        }
    },

    methods: {
        handleClick: function(event: Event): void {
            // In "actionable" mode the toggle doesn't flip — clicking triggers an action instead.
            if (this.actionable) {
                event.preventDefault();
                this.$emit("activate");
            }
        },
        handleChange: function(event: Event): void {
            const target = event.target as HTMLInputElement;
            const checked = target.checked;
            // Keep the input fully controlled by the `value` prop: revert the DOM
            // state immediately so the toggle only moves once the parent updates
            // `value`. Without this, cancelling a confirmation flow (e.g. the
            // deactivate modal) would leave the toggle visually flipped even
            // though the status never changed.
            target.checked = this.value;
            this.$emit("input", checked);
            this.$emit("change", checked);
        }
    }
});
